import { useContext, useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'
import { InstitutionContext } from '../../../Providers/InstitutionProvider'

const mapToOptions = sector => ({
  label: sector.name,
  value: sector.id,
  tooltip: sector.name,
  entity: sector
})

const SectorsSelector = ({
  checkable = false, disabled, dropdownMatchSelectWidth, dropdownStyle, empty = false, fallbackToContext = true, loading, maxTagCount, maxTagPlaceholder,
  multiple = false, sectors = [], selectorClassName, showSearch = false, tagPlaceholder, values, placeholder, onChange, filter, style = {}
}) => {
  const ic = useContext(InstitutionContext)

  const localSectors = sectors.length > 0 || !fallbackToContext || !ic ? sectors : ic.sectors

  const sectorOptions = useMemo(() => typeof filter === 'function'
    ? localSectors.filter(filter).map(mapToOptions)
    : localSectors.map(mapToOptions)
  , [localSectors, filter])

  return (
    <EntitiesSelector
      checkable={checkable}
      placeholder={placeholder}
      disabled={disabled}
      dropdownMatchSelectWidth={dropdownMatchSelectWidth}
      dropdownStyle={dropdownStyle}
      empty={empty}
      loading={loading}
      entityOptions={sectorOptions}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={maxTagPlaceholder}
      multiple={multiple}
      selectorClassName={selectorClassName}
      showSearch={showSearch}
      tagPlaceholder={tagPlaceholder}
      values={values}
      style={{ ...style }}
      onChange={onChange}
    />
  )
}

export default SectorsSelector
